import { IProduct } from '../redux/features/products/types';
import { AppState } from '../redux/reducers';
import { useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import {
  makeSelectProductAvailableTimes,
  selectActiveProduct,
} from '../redux/features/products/reducers/products';
import { selectActiveProductType } from '../redux/features/products/reducers/productTypes';
import { useTrans } from './trans';

export function useSelectProductAvailableTimes(product: IProduct) {
  const selectValidTimes = useMemo(makeSelectProductAvailableTimes, [
    product.id,
  ]);
  return useSelector((state: AppState) => selectValidTimes(state, product));
}

export function useSelectLabelForProductBookButton({
  product,
}: {
  product: IProduct;
}) {
  const { deviceType } = useSelector((state: AppState) => ({
    deviceType: state.deviceType,
    local: state.local,
  }));
  const viewType = useSelector(selectActiveProductType);

  // const product = useSelector(selectActiveProduct)
  const trans = useTrans();

  const [bookingButtonLabel, setBookingButtonLabel] = useState(
    trans('book_table_sold'),
  );
  const productStatus = product?.status;
  const productType = product?.product_type;

  useEffect(() => {
    //
    // booking label for product with stock
    //
    const labelInStockInMobile = trans(`book_table_${productType}`);
    if (
      labelInStockInMobile !== bookingButtonLabel &&
      productStatus === 'in-stock'
    ) {
      setBookingButtonLabel(labelInStockInMobile);
      return;
    }

    //
    // label product with no stock in mobile device
    //
    const labelNoStockInMobile = trans('see_product', {
      product: viewType.label,
    });
    if (
      labelNoStockInMobile !== bookingButtonLabel &&
      productStatus !== 'in-stock' &&
      deviceType === 'mobile'
    ) {
      setBookingButtonLabel(labelNoStockInMobile);
      return;
    }

    //
    // booking label for product with no stock
    //
    const labelNoStock = trans('book_table_sold');
    if (labelNoStock !== bookingButtonLabel && productStatus !== 'in-stock') {
      setBookingButtonLabel(labelNoStock);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productStatus, productType, deviceType, viewType]);

  return bookingButtonLabel;
}

export function useSelectActiveProduct() {
  return useSelector(selectActiveProduct);
}
